import { CloseButtonVariantType, } from '../../../../../../components/closeButton/types/closeButton';
import { CloseButtonStateType } from '../../../../../../components/closeButton/types/state';
import { containerPrimaryVariantsCommonStyles } from '../commonStyles';
export const getMainSectionStyles = (FOUNDATIONS, FONT) => {
    return {
        [CloseButtonVariantType.MAIN_SECTION]: {
            [CloseButtonStateType.DEFAULT]: {
                container: {
                    ...containerPrimaryVariantsCommonStyles(FOUNDATIONS, FONT),
                },
                iconColor: FOUNDATIONS.color_exception_neutral_icon_400,
            },
            [CloseButtonStateType.DISABLED]: {
                container: {
                    ...containerPrimaryVariantsCommonStyles(FOUNDATIONS, FONT),
                },
                iconColor: FOUNDATIONS.color_accent_disabled_icon_100,
            },
        },
    };
};
//# sourceMappingURL=mainSection.js.map